<div #container class="flex items-center h-full px-2">
  @if (breadcrumb) {
    <div class="hidden xl:flex items-center mr-6 pr-6 border-r border-gray-100">
      <span class="text-xs font-bold text-gray-400 uppercase tracking-widest">{{ breadcrumb }}</span>
    </div>
  }
  <div class="flex items-center space-x-2">
    <ng-content></ng-content>
  </div>
</div>
